var _circle, _circle2, _circle3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPasswordSentReso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 58.5,
    stroke: "#D3D3D3",
    strokeDasharray: "5 5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 49.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 50,
    fill: "#009639"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_reso_forgot)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 79C37.625 79 36.4483 78.5108 35.47 77.5325C34.4917 76.5542 34.0017 75.3767 34 74V44C34 42.625 34.49 41.4483 35.47 40.47C36.45 39.4917 37.6267 39.0017 39 39H79C80.375 39 81.5525 39.49 82.5325 40.47C83.5125 41.45 84.0017 42.6267 84 44V74C84 75.375 83.5108 76.5525 82.5325 77.5325C81.5542 78.5125 80.3767 79.0017 79 79H39ZM59 61.5L79 49V44L59 56.5L39 44V49L59 61.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_reso_forgot"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordSentReso);
export default __webpack_public_path__ + "static/media/forgot-password-sent-reso.464803729cb9eba6752805216683df8a.svg";
export { ForwardRef as ReactComponent };